const Separator = () => (
    <div style={{
        width: '100%',
        height: '1px',
        backgroundColor: '#eeeeee',
        margin: '1.5rem 0',
    }} />
);

export default Separator;